module.exports = __webpack_public_path__ + "resources/img/img_blue_prism1_jp.9620d90c7c35d229d1053ded95d0ce50.png";